<template>
  <div
    class="col-12"
  >
    <div class="card card--profile-tasks">
      <div
        v-b-toggle="`collapseOtherNotifications`"
        class="card-header"
      >
        <h3 class="float-start"> Archived notifications <span
          v-if="!loading"
          class="badge bg-light-info"
        >{{ total }}</span>
        </h3>
        <div class="heading-elements heading-elements-custom">
          <ul class="list-inline mb-0 disp-in ms-2">
            <li>
              <span
                class="dis-ib"
              >
                <a
                  class="btn btn-icon btn-icon rounded-circle btn-flat-secondary"
                  @click.stop="openFilters"
                >
                  <i data-feather="filter" />
                </a>
              </span>
              <a data-action="collapse"><svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-chevron-down"
              ><polyline points="6 9 12 15 18 9" /></svg></a>
            </li>
          </ul>
        </div>
      </div>
      <b-collapse
        :id="`collapseOtherNotifications`"
        :visible="!fields.find(e => e.name == 'Other notifications') || fields.find(e => e.name == 'Other notifications').visibility"
      >
        <div class="card-body">
          <div
            v-if="loading"
            class="loading position-relative"
          >
            <div class="effect-1 effects" />
            <div class="effect-2 effects" />
            <div class="effect-3 effects" />
          </div>
          <div
            v-else
            class="table-responsive"
          >
            <table class="table table-striped table-hover">
              <thead>
                <tr>
                  <th>Date entry</th>
                  <th>Title</th>
                  <th class="text-end">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in items"
                  :key="index"
                >
                  <td>{{ item.date }}</td>
                  <td>{{ item.title }}</td>
                  <td class="text-end">
                    <a
                      @click="$emit('showAlert', item)"
                    >
                      <i data-feather="eye" />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="mt-1">
            <Paginator
              :total="total"
              :store="'-'"
              @loading="reloadData"
            />
          </div>
        </div>
      </b-collapse>
    </div>
    <ConvoFilter
      filter-path="-"
      :filter-token="filterToken"
      @appliedFilters="applyFilters"
    >
      <template #filters>
        <div class="mb-1">
          <label
            for="filterType"
            class="form-label"
          >Type</label>
          <select
            id="filterType"
            v-model="filterType"
            class="form-select"
          >
            <option value="">
              All
            </option>
            <option value="2">
              Notification
            </option>
            <option value="1">
              Task
            </option>
          </select>
        </div>
        <div class="mb-1">
          <label
            for="filterTitle"
            class="form-label"
          >Title</label>
          <input
            id="filterTitle"
            v-model="filterTitle"
            type="text"
            class="form-control"
            placeholder="Search by title..."
          >
        </div>
        <div class="mb-1">
          <label
            for="filterDateFrom"
            class="form-label"
          >Date from</label>
          <input
            id="filterDateFrom"
            v-model="filterDateFrom"
            type="date"
            class="form-control"
          >
        </div>
        <div class="mb-1">
          <label
            for="filterDateTo"
            class="form-label"
          >Date to</label>
          <input
            id="filterDateTo"
            v-model="filterDateTo"
            type="date"
            class="form-control"
          >
        </div>
      </template>
    </ConvoFilter>
  </div>
</template>

<script>
import { BCollapse } from 'bootstrap-vue'
import Paginator from '@/views/back/partials/Paginator.vue'
import ConvoFilter from '@/views/back/partials/offcanvas/ConvoFilter.vue'
import { mapGetters } from 'vuex'
import Vue from 'vue'

export default {
  components: {
    BCollapse,
    Paginator,
    ConvoFilter,
  },
  data() {
    return {
      userId: this.$route.params.id,
      loading: false,
      selectedItems: [],
      clicked: false,
      items: [],
      total: 0,
      filterType: '',
      filterTitle: '',
      filterDateFrom: '',
      filterDateTo: '',
      filterToken: (Math.random() + 1).toString(36).substring(7),
    }
  },
  computed: {
    ...mapGetters({
      fields: 'modals/tableSettingsFields',
      loggedUser: 'auth/admin',
      items: 'alerts/general',
      filters: 'filters/filters',
    }),
  },
  watch: {
    filters: {
      handler(newVal) {
        // When filters are cleared from the store, reset local filters
        if (Object.keys(newVal).length === 0) {
          this.filterType = ''
          this.filterTitle = ''
          this.filterDateFrom = ''
          this.filterDateTo = ''
          this.reloadData()
        }
      },
      deep: true,
    },
  },
  async mounted() {
    this.reloadData()

    feather.replace({
      width: 14,
      height: 14,
    })
  },
  methods: {
    openFilters() {
      this.$store.dispatch('modals/toggleConvoFilters', true)
      this.$store.dispatch('modals/toggleActiveFilterTab', this.filterToken)
      setTimeout(() => {
        feather.replace({
          width: 14,
          height: 14,
        })
      }, 100)
    },
    async applyFilters() {
      await this.reloadData()
    },
    async reloadData() {
      this.loading = true
      const filters = {
        archived: true,
      }
      if (this.filterType) {
        filters.type = {
          value: this.filterType
        }
      }
      if (this.filterTitle) {
        filters.title = this.filterTitle
      }
      if (this.filterDateFrom) {
        filters.begin_date = this.filterDateFrom
      }
      if (this.filterDateTo) {
        filters.end_date = this.filterDateTo
      }
      const resp = await Vue.prototype.$http.post(`${Vue.prototype.$alertUrl}/alerts/filter`, filters)
      this.items = resp.data.data.data
      this.total = resp.data.total
      this.loading = false
    },
  },
}
</script>
